import Modal from "../General/Modal"
import { useState } from "react"
import styled from "styled-components"

const StyledDiv = styled.div`
    width : 100%;
    height : 40px;
    border-radius : 4px;
    border : 1px solid grey;
    overflow-x : auto;
    margin-right : 10px;
`

function Share({ show, url, close } : any) {
    const [showToolTip, setShowToolTip] = useState(false);
    const [tooltipTitle, setTooltipTitle] = useState('Copy')

    // FUNCTIONS
    const copyURL = () => {
        navigator.clipboard.writeText(url);
        setTooltipTitle('Copied!');

        setTimeout(() => {
            setTooltipTitle('Copy');
        }, 5000);
    }
    return (
        <Modal show={show} styles='w-[90%] lg:w-2/5' transition='animateup'>
            <div className="content pt-4 pb-4 px-8">
                <div className="flex items-center justify-between">
                    <h2 className="text-theme-black font-semibold text-2xl flex items-center justify-start"> 
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 mr-5">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M7.217 10.907a2.25 2.25 0 100 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186l9.566-5.314m-9.566 7.5l9.566 5.314m0 0a2.25 2.25 0 103.935 2.186 2.25 2.25 0 00-3.935-2.186zm0-12.814a2.25 2.25 0 103.933-2.185 2.25 2.25 0 00-3.933 2.185z" />
                        </svg>

                        Share this Page
                    </h2>
                    <svg onClick={() => close()} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 cursor-pointer">
                       <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </div>

                <div className="flex items-center">
                    <StyledDiv className="flex items-center justify-center my-10">
                        { url }
                    </StyledDiv>

                    <div className="relative">
                        {showToolTip && 
                            <div className="text-sm text-center bg-black bg-opacity-60 text-white py-1 absolute -top-10 right-0 rounded min-w-[100px]"> {tooltipTitle} </div>
                        }
                        
                        <svg onClick={copyURL} onMouseEnter={() => setShowToolTip(true)} onMouseLeave={() => setShowToolTip(false)} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 cursor-pointer">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 7.5V6.108c0-1.135.845-2.098 1.976-2.192.373-.03.748-.057 1.123-.08M15.75 18H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08M15.75 18.75v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5A3.375 3.375 0 006.375 7.5H5.25m11.9-3.664A2.251 2.251 0 0015 2.25h-1.5a2.251 2.251 0 00-2.15 1.586m5.8 0c.065.21.1.433.1.664v.75h-6V4.5c0-.231.035-.454.1-.664M6.75 7.5H4.875c-.621 0-1.125.504-1.125 1.125v12c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V16.5a9 9 0 00-9-9z" />
                        </svg>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default Share